// removed by extract-text-webpack-plugin
module.exports = {"general-settings-page":"general-settings-page","form-group":"form-group","control-switch":"control-switch","control-switch-content":"control-switch-content"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/settings/scene/general/general.style.sass
// module id = 0jNc
// module chunks = 0